<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'App',
  methods: {
    ...mapMutations(['handleIsLogin']) // 确保 mutation 名称一致
  },
  created () {
    // 1. 恢复 isActive（你已有的逻辑）
    const savedActive = sessionStorage.getItem('isActive')
    if (savedActive) {
      this.$store.state.isActive = savedActive
    } else {
      sessionStorage.setItem('isActive', 'homeActive')
    }

    // 2. 👇 新增：恢复 isLogin 状态
    const isLogin = localStorage.getItem('isLogin') === 'true'
    this.handleIsLogin(isLogin)

    // 3. 监听页面卸载，保存 isActive（你已有的）
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('isActive', this.$store.state.isActive)
    })
  }
}
</script>
